/* eslint-disable @typescript-eslint/naming-convention */
import { Cookies } from "react-cookie";
import { CookieSetOptions } from "universal-cookie";

export interface UserCredentials {
  accessToken: string;
  expiresIn: number;
  oid: string;
  refreshToken?: string;
  sessionId?: string;
  tokenType?: string;
  dateTime?: string;
}

enum cookiesSessionParams {
  access_token = "access_token",
  refresh_token = "refresh_token",
  access_token_expiration_time = "access_token_expiration_time",
  access_token_datetime = "access_token_datetime",
}

const cookies = new Cookies();

const options: CookieSetOptions = {
  path: "/",
  domain: ".gosuslugi.ru",
  secure: true,
  sameSite: "none",
};

export const hasAccessTokenCookie = (): boolean => {
  const accessToken = cookies.get(cookiesSessionParams.access_token);

  console.debug("accessToken");
  console.debug(accessToken);

  if (accessToken) {
    return true;
  }
  return false;
};

export const setAccessTokenCookie = (
  userCredentials: UserCredentials
): void => {
  const { expiresIn, accessToken, refreshToken, dateTime } = userCredentials;
  const {
    access_token,
    refresh_token,
    access_token_datetime,
    access_token_expiration_time,
  } = cookiesSessionParams;
  const expires = new Date(dateTime);
  const params = { expires, ...options };

  expires.setTime(expires.getTime() + expiresIn * 1000);

  cookies.set(access_token, accessToken, params);
  cookies.set(refresh_token, refreshToken, params);
  cookies.set(access_token_datetime, dateTime, params);
  cookies.set(access_token_expiration_time, expiresIn, params);
};

export const removeAccessTokenCookie = (): void => {
  const {
    access_token,
    refresh_token,
    access_token_datetime,
  } = cookiesSessionParams;

  cookies.remove(access_token);
  cookies.remove(refresh_token);
  cookies.remove(access_token_datetime);
};

export const getSessionCookies = () => {
  const {
    access_token,
    refresh_token,
    access_token_datetime,
    access_token_expiration_time,
  } = cookiesSessionParams;

  return {
    [access_token]: cookies.get(access_token),
    [refresh_token]: cookies.get(refresh_token),
    [access_token_datetime]: cookies.get(access_token_datetime),
    [access_token_expiration_time]: cookies.get(access_token_expiration_time),
  };
};
